// @core/api/endpoints/workflow/list_schedules.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListSchedulesResponse,
} from '../../../types/workflow';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/workflow';

/**
 * List pipeline schedules
 * Returns all schedules configured for a pipeline.
 */
export async function ListSchedules(
  pipeline_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListSchedulesResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/schedules`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.get<ListSchedulesResponse>(requestPath, { ...requestOptions, params });
}
